/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiServicesDataTransferObjectsGroupServiceCreateGroupResultDto
 */
export interface WebApiServicesDataTransferObjectsGroupServiceCreateGroupResultDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceCreateGroupResultDto
     */
    id?: number;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsGroupServiceCreateGroupResultDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsGroupServiceCreateGroupResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsGroupServiceCreateGroupResultDtoFromJSON(json: any): WebApiServicesDataTransferObjectsGroupServiceCreateGroupResultDto {
    return WebApiServicesDataTransferObjectsGroupServiceCreateGroupResultDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsGroupServiceCreateGroupResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsGroupServiceCreateGroupResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function WebApiServicesDataTransferObjectsGroupServiceCreateGroupResultDtoToJSON(value?: WebApiServicesDataTransferObjectsGroupServiceCreateGroupResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

